// ── IST-aware report period helpers ────────────────────────────────────────
// The backend windows reports by IST calendar dates; presets here produce the
// same IST boundaries so the picker and server agree on "today".
const istParts = (d = new Date()) => {
  // en-CA gives YYYY-MM-DD; the Asia/Kolkata TZ shifts to the IST calendar day.
  const [y, m, day] = d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }).split("-");
  return { y: Number(y), m: Number(m), d: Number(day) };
};
const iso = (y, m, d) => `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
// Add `days` to an IST date string, returning a new YYYY-MM-DD (noon-anchored to
// avoid DST/offset drift when re-parsing).
const addDays = (isoStr, days) => {
  const d = new Date(`${isoStr}T12:00:00`);
  d.setDate(d.getDate() + days);
  const p = istParts(d);
  return iso(p.y, p.m, p.d);
};
const lastOfMonth = (y, m) => new Date(y, m, 0).getDate();

// Today on the IST calendar, YYYY-MM-DD — the bound for date pickers that the
// backend checks against IST too (e.g. an invoice date can't be in the future).
export const todayIST = () => {
  const p = istParts();
  return iso(p.y, p.m, p.d);
};

export function presetRange(key) {
  const t = istParts();
  const today = iso(t.y, t.m, t.d);
  switch (key) {
    case "today":
      return { from: today, to: today };
    case "last30":
      return { from: addDays(today, -29), to: today };
    case "last_month": {
      const m = t.m === 1 ? 12 : t.m - 1;
      const y = t.m === 1 ? t.y - 1 : t.y;
      return { from: iso(y, m, 1), to: iso(y, m, lastOfMonth(y, m)) };
    }
    case "this_year":
      return { from: iso(t.y, 1, 1), to: iso(t.y, 12, 31) };
    case "this_month":
    default:
      return { from: iso(t.y, t.m, 1), to: iso(t.y, t.m, lastOfMonth(t.y, t.m)) };
  }
}

export const PRESETS = [
  { key: "this_month", label: "This Month" },
  { key: "last_month", label: "Last Month" },
  { key: "today", label: "Today" },
  { key: "last30", label: "Last 30 Days" },
  { key: "this_year", label: "This Year" },
];
